import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAngleDown,
  faAngleRight,
  faArrowUpRightFromSquare,
  faCheck,
  faCheckCircle as faCheckCircleSolid,
  faCircleExclamation,
  faCircleInfo,
  faComments,
  faComputer,
  faCopy,
  faEllipsisVertical,
  faFileAudio,
  faGear,
  faInfoCircle,
  faKeyboard,
  faLanguage,
  faMicrophone,
  faMinus,
  faMoon,
  faPen,
  faPenToSquare,
  faPlus,
  faReceipt,
  faSearch,
  faSitemap,
  faSun,
  faSwatchbook,
  faThumbsDown,
  faThumbsUp,
  faTimesCircle,
  faTrash,
  faTriangleExclamation,
  faVolumeHigh,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCheckCircle,
  faListAlt,
  faUserCircle,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faAngleDown,
  faAngleRight,
  faSearch,
  faUserCircle,
  faSitemap,
  faListAlt,
  faThumbsUp,
  faReceipt,
  faThumbsDown,
  faGear,
  faMicrophone,
  faInfoCircle,
  faCopy,
  faTimesCircle,
  faCheckCircle,
  faCheckCircleSolid,
  faLanguage,
  faKeyboard,
  faFileAudio,
  faVolumeHigh,
  faCheck,
  faXmark,
  faPlus,
  faMinus,
  faEllipsisVertical,
  faPen,
  faPenToSquare,
  faTrash,
  faCircleExclamation,
  faTriangleExclamation,
  faCircleInfo,
  faArrowUpRightFromSquare,
  faSwatchbook,
  faComments,
  faMoon,
  faSun,
  faComputer,
)
